import * as React from 'react';
import * as moment from 'moment';

import { IWACEvent } from '../classes/event';
import Image from '../components/image';
import { IDay } from '@adage/calendar/services/calendar';

export interface ListViewEventProps {
    event: IWACEvent;
}

const listEvent: React.SFC<ListViewEventProps> = (props) => {
    const dateMoment = moment(props.event.eventDate);
    var venueName;// = props.event.tessVenueName ? `${props.event.tessVenueName} in ${props.event.venueName.toUpperCase()}` : props.event.venueName.toUpperCase();
    switch (props.event.venueName.toUpperCase()) {
        case "WAC":
            venueName = "Walton Arts Center";
            break;
        case "AMP":
            venueName = "Walmart AMP"
            break;
        case "OTHER":
            venueName = props.event.venueOnPage
            break;
        default:
            break;
    }
    return (
        <article className="list-day-event">
            <div className="list-day-event-image">
                <div className="list-day-event-image-inner">
                    <Image srcUrl={props.event.imageUrl} date={moment(props.event.eventDate)} />
                </div>
            </div>
            <div className="list-day-event-details">
                <div className="list-day-event-info">
                    <a href={props.event.detailsLink} className="list-day-event-title"><h4>{props.event.name}</h4></a>
                    <p className="list-day-event-time">{dateMoment.format("mm") === "00" ? dateMoment.format("ha") : dateMoment.format("h:mma")}</p>
                    <p className="list-day-event-venue">{venueName}</p>
                </div>
                <div className="list-day-event-cta">
                    {
                        props.event.soldOut ?
                            <p className="list-day-event-unavailable">Sold Out</p>
                            :
                            <a href={props.event.buyTicketsLink} className="list-day-event-cta-btn btn">{props.event.buyTicketsLabel}</a>
                    }
                </div>
            </div>
        </article>
    );
}

export default listEvent;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/list-event.tsx